import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App } from '../../App';
import { Public } from '../../Public';
import { Login } from '../../auth/components/Login';
import { Logout } from '../../auth/components/Logout';
import { Demo } from '../../viewer/components/Demo';
import { NotFound } from './NotFound';
import { RequiresAuth } from '../../auth/components/RequiresAuth';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Public />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        element: <Demo />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'logout',
        element: <Logout />,
      },
      {
        path: 'app/*',
        element: (
          <RequiresAuth>
            <App />
          </RequiresAuth>
        ),
      },
    ],
  },
]);

export const Router = () => {
  return <RouterProvider router={router} />;
};
